import { hits, configure } from "instantsearch.js/es/widgets";
import { getInstance, registerWidget } from "./algolia-create-instance";
import { renderHitTemplate as fallbackTemplate } from "../../hits-templates/default-template.js";
import { preFilterHits } from './algolia-pre-filter.js';
import { applyFilters, addFilter } from '@wordpress/hooks';

function initHitsWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblAlgoliaDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);
  // TODO: Translations
  //const LOCALIZED = tgblAlgoliaData.localized;

  const elements = document.querySelectorAll("[data-filter-type='hits']");
  const elementsArray = Array.from(elements);

  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute("data-index");
    if (!acc[dataIndexValue]) {
      acc[dataIndexValue] = [];
    }
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  for (const dataIndexValue in elementsGroupedByIndex) {
    if (elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) {
      const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
      let search = getInstance(dataIndexValue);
      
      elementsWithSameIndex.forEach(async element => {
        
        const widgetID = element.getAttribute('data-id');
        const widget = tgblAlgoliaData[widgetID]
        const templatePath = widget['template_path'];
        const preFilterItemsObject = widget['pre_filter_items'];

        if ( preFilterItemsObject ) {
          let preFilterItems = Object.values( preFilterItemsObject ).flat();

          if ( preFilterItems.length !== 0 ) {
            preFilterHits( preFilterItems, dataIndexValue );
          }
        } 
      
        let renderHitTemplate = fallbackTemplate

        if (templatePath) {
          try {
            const module = await import(templatePath);
            renderHitTemplate = module.default || module.renderHitTemplate;
          } catch (error) {
            console.error(
              `Error loading template from ${templatePath}:`,
              error,
            );
          }
        }

        let AlgoliaHits = ($, search, element) => {
          search.addWidgets([
            hits({
              container: element,
              templates: {
                item: (hit, { html, component }) => {
                  const template = renderHitTemplate(hit, { html, component }, widgetID);
                  const event = new CustomEvent("algoliaRenderTemplate", {});
                  window.dispatchEvent(event);
                  return applyFilters(
                    'tangible-algolia-hit-template',
                    template,
                    { hit, html, component, widget }
                  )
                },
              },
              cssClasses: {
                list: ["tgblAlgolia-grid", "tgblAlgolia-grid--density-16"],
                item: [
                  "tgblAlgolia-card tgblAlgolia-card--is-style-elevated tgblAlgolia-card--has-interaction",
                ],
              },
            }),
          ]);
          registerWidget(element);
        };
        AlgoliaHits($, search, element);
      });
    }
  }
}
  
export { initHitsWidget }